export default ((country, settings, isInJapanLoqateExperiment) => {
    const isV4Country = !!settings?.v4_address_lookup_countries?.includes(country);
    const isV3Country = !!settings?.address_lookup_countries?.includes(country);
    const hasV4Key = !!settings?.v4_loqate_capture_key;
    const hasV3Key = !!settings?.loqate_capture_key;
    
    const canUseV4 = isInJapanLoqateExperiment && isV4Country && hasV4Key;
    const canUseV3 = !isInJapanLoqateExperiment && isV3Country && hasV3Key;
    const isKorea = country === 'KR';
    const isCountrySupported = isV4Country || isV3Country;
    return isCountrySupported && (canUseV4 || canUseV3 || isKorea);
});
